export default __webpack_public_path__ + "static/media/poschP.e07a678c.jpg";